export const BADGES = [
  { id: "streak_3", days: 3, name: "Fresh Roll", blurb: "3 days in a row", color: "#FFC800" },
  { id: "streak_7", days: 7, name: "Double Ply", blurb: "7 days in a row", color: "#1CB0F6" },
  { id: "streak_30", days: 30, name: "Golden Roll", blurb: "30 days in a row", color: "#58CC02" },
];

export const badgeById = (id) => BADGES.find((b) => b.id === id);
